import { treatsItems } from '@/business/apiTreatment/response/baseAPITreatment';
import BaseService from '@/services/services/tools/baseService';
import AlertsAPI, {
  getSensorsQualityFromList,
  getEnergyCasesFromList,
} from '@/services/api/internal/alerts.api';

const treatListResponse = treatsItems({
  datetimeFieldNames: [
    'alerte_chauff_datetime',
    'alerte_ecs_chauff_datetime',
    'alerte_conso_datetime',
    'alerte_conso_pct_datetime',
    'alerte_conso_total_datetime',
    'alerte_ecs_datetime',
    'alerte_legio_datetime',
    'autres_alertes_datetime',
  ],
  booleanFieldNames: ['top_p1'],
});

const AlertsService = new BaseService({
  api: AlertsAPI,
  treatListResponse,
});

export const UntreatedAlertsService = new BaseService({
  api: AlertsAPI,
  urlParamsItems: { untreated: true },
  treatListResponse,
});

export function getSensorsQuality(items) {
  let idList = items.map((item) => item.property_id);
  idList = idList.filter(
    (item, index) => idList.findIndex((id) => id === item) === index
  );
  return getSensorsQualityFromList(idList);
}

export function getEnergyCases(items) {
  const idList = items.filter(
    (item, index) => items.findIndex((id) => id === item) === index
  );
  return getEnergyCasesFromList(idList);
}

export default AlertsService;
